// extracted by mini-css-extract-plugin
export default {"wrapper":"src-components-common-Loading-index__wrapper--hvoov"};